module.exports = {
  TheExpiredAndNoCreated: 'สัญญาของหน่วยงานที่มอบหมายสิ้นสุดแล้ว ไม่สามารถสร้างธุรกิจใหม่ได้!',
  NotTheCorrectOperationStatus: 'ไม่อยู่ในสถานะปฏิบัติการปกติ',
  NoDataSelected: 'ยังไม่ได้เลือกข้อมูล',
  AllAreInNonStatus: 'ข้อมูลที่เลือกทั้งหมดอยู่ในสถานะไม่ใช่【ปฏิบัติการปกติ】',
  ThisSelfConsolidationBuyerConsolidation: 'ประเภทการรวมตู้ของธุรกรรมนี้ไม่ใช่แบบตู้รวมเอง, buyer consol หรือตู้รวมที่มอบหมาย',
  AttachmentContentTooLarge: 'เนื้อหาของไฟล์แนบมีขนาดใหญ่เกินไป',
  AreWantToWithdrawBill: 'แน่ใจหรือไม่ที่จะยกเลิกธุรกรรมนี้?',
  SplitOrder: 'แยกเอกสาร',
  MergeOrder: 'รวมเอกสาร',
  SRIFailedPleaseContactTroubleshooting: 'การส่งใบมอบหมายของ SIRUI ล้มเหลว กรุณาติดต่อเจ้าหน้าที่เพื่อตรวจสอบ:',
  OperationSuccessful: 'ดำเนินการสำเร็จ',
  ContainerType: 'ประเภทตู้',
  LockedPrintedPleaseContactUnlocking: 'ถูกล็อคอยู่ ไม่สามารถพิมพ์ได้ กรุณาติดต่อผู้ดูแลเพื่อปลดล็อค!',
  FullContainerProfitPrint: 'พิมพ์กำไรตู้เต็ม',
  LCLProfitPrint: 'พิมพ์กำไรตู้รวม',
  NoSubTicketSelected: 'ยังไม่ได้เลือกใบรายการย่อย',
  CustomersSuchAsPOEtc: 'หมายถึงหมายเลขที่ลูกค้ากำหนดสำหรับการขนส่งสินค้า เช่น PO NBR, ITEM NBR เป็นต้น',
  OriginalBillOfLading: 'ต้นฉบับ',
  TelexRelease: 'ปล่อยทางอิเล็กทรอนิกส์',
  NoLoadingInformationSelected: 'ยังไม่ได้เลือกข้อมูลการบรรจุตู้',
  PleaseASubTicketRecord: 'กรุณาเลือกบันทึกใบรายการย่อย',
  PleaseSelectAContainer: 'กรุณาเลือกตู้อย่างน้อยหนึ่งตู้',
  BillOfLadingInformationTracking: 'ติดตามข้อมูลใบตราส่งสินค้า',
  ReleaseNumber: 'หมายเลขปล่อยเอกสาร:',
  Unknown: 'ไม่ทราบ',
  ViewExceptions: 'ดูความผิดปกติ',
  PleaseSelectDesignatedData: 'กรุณาเลือกข้อมูลที่กำหนด',
  LicenseOfLadingNumberEmpty: 'หมายเลขทะเบียนรถและหมายเลขใบตราส่งสินค้าไม่สามารถเว้นว่างได้',
  NoRelevantInformationAvailable: 'ยังไม่มีข้อมูลที่เกี่ยวข้อง',
  DoToDeleteTheTicket: 'ต้องการลบใบรายการย่อยหรือไม่?',
  AuditSuccessful: 'ตรวจสอบสำเร็จ',
  Allocation: 'กระจายสินค้า',
  ChangeOrders: 'เปลี่ยนเอกสาร',
  ImportManifest: 'ใบรายการสินค้านำเข้า'
}
